<template>
  <div class="menu">
    <el-menu
      :default-active="defaultActive"
      :collapse="isCollapse"
      @select="selectMenu"
      router
      :unique-opened="true"
    >
      <div v-for="item in menuArr" :key="item.id">
        <el-menu-item
          v-if="!item.children || item.children?.length == 0"
          :index="item.url"
          class="level1"
        >
          <template v-if="item.icon">
            <i :class="item.icon" v-if="item.icon.startsWith('el-')"></i>
            <div
              class="custom_icon"
              :class="`${item.icon}${item.url == currentLevel1 ? '_s' : ''}`"
              v-else
            ></div>
          </template>

          <span slot="title">{{ item.name }}</span>
        </el-menu-item>
        <Submenu
          v-else
          :menuInfo="item"
          :level="1"
          :currentLevel1="currentLevel1"
        />
      </div>
    </el-menu>
  </div>
</template>

<script>
import Submenu from "./Submenu";
export default {
  components: {
    Submenu,
  },
  props: {
    menuArr: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },

  data() {
    return {
      isCollapse: false,
      currentLevel1: "",
      defaultActive: this.$route.path.substr(1),
    };
  },
  mounted() {},
  methods: {
    selectMenu(index, indexPath) {
      this.currentLevel1 = indexPath[0];
    },
  },
};
</script>

<style lang="scss" scoped>
.custom_icon {
  display: inline-block;
  margin-right: 5px;
  width: 18px;
  height: 18px;
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
.menu {
  padding: 24px 20px;
}
</style>
